import * as React from "react"
const Svgyuzbireseksendokuz = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1133.86 1133.86"
    {...props}
  >
    <defs>
      <style>
        {
          '.st1,.st14,.st2,.st5,.st7,.st9{stroke-miterlimit:10}.st1,.st14,.st2,.st9{fill:none}.st1,.st14,.st5,.st7,.st9{stroke-width:2px}.st9{stroke:#fff}.st1,.st14,.st5,.st7{stroke:#231f20}.st2{stroke:#1d1d1b;stroke-width:.25px}.st15,.st2{font-family:ArialMT,Arial;font-size:12.83px;isolation:isolate}.st16{fill:#fff;font-family:MyriadPro-Regular,"Myriad Pro";font-size:18px}.st5{fill:#fbb040}.st7{fill:#70bf45}.st14{display:none}.st15{fill:#1d1d1b}'
        }
      </style>
    </defs>
    <g id="Layer_6">
      <g id="katman_7">
        <path
          d="M219.09 981.21h16v16h-16z"
          style={{
            fill: "#fbb03c",
            stroke: "#fbb03c",
            strokeMiterlimit: 10,
          }}
        />
        <path
          d="M219.09 1012.21h16v16h-16z"
          style={{
            fill: "#6abd45",
            stroke: "#6abd45",
            strokeMiterlimit: 10,
          }}
        />
        <path
          d="M219.09 1043.21h16v16h-16z"
          style={{
            fill: "#55a2d9",
            stroke: "#55a2d9",
            strokeMiterlimit: 10,
          }}
        />
        <text className="st15" transform="rotate(.03 -1901428.526 469788.446)"> <tspan x={0} y={0}> {"SATILDI"}</tspan></text>
        <text className="st2" transform="rotate(.03 -1901428.526 469788.446)"><tspan x={0} y={0}>{"SATILDI"}</tspan></text>
        <text className="st15" transform="rotate(.03 -1963708.187 473051.511)"><tspan x={0} y={0}>{"SATI\u015ETA"}</tspan></text>
        <text className="st2" transform="rotate(.03 -1963708.187 473051.511)"><tspan x={0} y={0}>{"SATI\u015ETA"}</tspan></text>
        <text className="st15" transform="rotate(.03 -2020889.938 470908.34)">
          <tspan x={0} y={0}>{"OPS\u0130YON"}</tspan></text><text className="st2" transform="rotate(.03 -2020889.938 470908.34)"><tspan x={0} y={0}>{"OPS\u0130YON"}</tspan></text>
      </g>
    </g>
    <g id="Layer_7">
      <g><path d="M409.39 1134h47.36v-55.22l-6.66-22.42-74.29-168.77 8.25-30.27 99.06-54.11 113.73-65.12 115.57-65.12 127.49-75.21-11.01-39.44-101.81 59.62-23.84-10.09-39.44-119.24-25.69-80.71-25.68-78.88 3.67-30.27 96.31-165.09L810.47 0h-52.28L700.4 79.85 563.94 308.84l68.67 206.37 38.52 114.65-11 24.76-146.75 88.97-108.23 59.62-93.56 51.36 97.8 225.59V1134z"
        style={{fill: "#bcbec0",stroke: "#bcbec0",strokeWidth: 2,strokeMiterlimit: 10,}}/></g>
      <g id="katman_2"><path d="M450.09 1056.36 375.8 887.59l8.25-30.27 99.06-54.11 83.82 188.03-116.84 65.12z"/></g>
      <g id="katman_2"><path d="m566.93 991.24 112.46-66.04-82.55-187.11-113.73 65.12 83.82 188.03z"/></g>
      <g id="katman_2"><path d="M596.84 738.09l115.57-65.12 79.79 187.11-112.81 65.12-82.55-187.11z"/></g>
      <g id="katman_2"><path d="m712.41 672.97 127.49-75.21 53.2 201.32-100.9 61-79.79-187.11z"/></g>
      <g id="katman_2"><path d="M311.59 854.57l-90.8-207.28 83.46-25.68 16.51-9.18 84.39 190.78-93.56 51.36z"/></g>
      <g id="katman_2"><path d="M320.76 612.43l102.73-77.04 89.89 208.2-108.23 59.62-84.39-190.78z"/></g>
      <g id="katman_2"><path d="m456.75 612.43 175.86-97.22 38.52 114.65-11 24.76-146.75 88.97-56.63-131.16z"/></g>
      <g id="katman_2"><path d="m423.49 535.39 74.29-55.95 45.86-135.75 20.3-34.85 68.67 206.37-175.86 97.22-33.26-77.04z"/></g>
      <g id="katman_2"><path d="M616.1 298.75l96.31-165.09 55.03 199.03-129.33 75.21-25.68-78.88 3.67-30.27z"/></g>
      <g id="katman_2"><path d="m663.8 488.61 128.4-71.54 36.69 141.25-101.81 59.62-23.84-10.09-39.44-119.24z"/></g>
      <g id="katman_2"><path d="m663.8 488.61-25.69-80.71 129.33-75.21 24.76 84.38-128.4 71.54z"/></g>
      <g><path d="M563.94 308.84 694.52 89.72 758.19 0M712.41 133.66 810.47 0M409.39 1134v-53.84l-97.8-225.59M456.75 1134v-55.22l-6.66-22.42" className="st1"/></g>
      <g><path d="m785.71 0-3.58 4.82" className="st9" /></g>
      <g><path d="m774.85 14.61-68.95 92.76-109.55 190.97" style={{strokeDasharray: "12.21 12.21",stroke: "#fff",strokeWidth: 2,fill: "none",strokeMiterlimit: 10,}}/></g>
      <g><path d="m593.31 303.64-2.99 5.2 1.86 5.71" className="st9" /></g>
      <g><path d="m595.93 326.06 103 316.7" style={{stroke: "#fff",strokeWidth: 2,fill: "none",strokeMiterlimit: 10,strokeDasharray: "12.11 12.11",}}/></g>
      <g><path d="m700.8 648.52 1.86 5.71-5.22 2.97" className="st9" /></g>
      <g><path d="M687 663.15 363.3 847.62l-13.76 39.91 73.95 174.74 9.98 19.26 3.18 40.5"style={{strokeDasharray: "12.02 12.02",stroke: "#fff",strokeWidth: 2,fill: "none",strokeMiterlimit: 10,}}/></g>
      <g><path d="m437.13 1128.02.47 5.98" className="st9" /></g>
      <g><path d="m702.66 654.23 132.13-74.79" style={{strokeDasharray: 12,stroke: "#fff",strokeWidth: 2,fill: "none",strokeMiterlimit: 10,}}/></g>
    </g>

    <g id="Layer_8">
      <text className="st16" transform="translate(456.21 922.92)"><tspan x={0} y={0}>{"P11"}</tspan></text>
      <text className="st16" transform="translate(436.29 943.93)"><tspan x={0} y={0}>{"250.00m\xB2"}</tspan></text>
      <text className="st16" transform="translate(570.86 850.25)"><tspan x={0} y={0}>{"P10"}</tspan></text>
      <text className="st16" transform="translate(550.94 871.25)"><tspan x={0} y={0}>{"250.00m\xB2"}</tspan></text>
      <text className="st16" transform="translate(683.64 792.71)"><tspan x={0} y={0}>{"P09"}</tspan></text>
      <text className="st16" transform="translate(663.72 813.71)"><tspan x={0} y={0}>{"250.00m\xB2"}</tspan></text>
      <text className="st16" transform="translate(800.11 723)"><tspan x={0} y={0}>{"P08"}</tspan></text>
      <text className="st16" transform="translate(780.2 744.01)"><tspan x={0} y={0}>{"250.00m\xB2"}</tspan></text>
      <text className="st16" transform="translate(303.92 723)"><tspan x={0} y={0}>{"P01"}</tspan></text>
      <text className="st16" transform="translate(284 744.01)"><tspan x={0} y={0}>{"209.87m\xB2"}</tspan></text>
      <text className="st16" transform="translate(401.14 665.23)"><tspan x={0} y={0}>{"P02"}</tspan></text>
      <text className="st16" transform="translate(381.22 686.23)"><tspan x={0} y={0}>{"250.00m\xB2"}</tspan></text>
      <text className="st16" transform="translate(516.25 507)"><tspan x={0} y={0}>{"P03"}</tspan></text>
      <text className="st16" transform="translate(496.33 528.01)"><tspan x={0} y={0}>{"249.87m\xB2"}</tspan></text>
      <text className="st16" transform="translate(553.08 618.9)"><tspan x={0} y={0}>{"P04"}</tspan></text>
      <text className="st16" transform="translate(533.16 639.9)"><tspan x={0} y={0}>{"250.00m\xB2"}</tspan></text>
      <text className="st16" transform="translate(671.89 302.65)"><tspan x={0} y={0}>{"P05"}</tspan></text>
      <text className="st16" transform="translate(651.97 323.65)"><tspan x={0} y={0}>{"209.89m\xB2"}</tspan></text>
      <text className="st16" transform="translate(703.47 406.57)"><tspan x={0} y={0}>{"P06"}</tspan></text>
      <text className="st16" transform="translate(683.55 427.57)"><tspan x={0} y={0}>{"121.34m\xB2"}</tspan></text>
      <text className="st16" transform="translate(735.08 512.92)"><tspan x={0} y={0}>{"P07"}</tspan></text>
      <text className="st16" transform="translate(715.16 533.93)"><tspan x={0} y={0}>{"185.07m\xB2"}</tspan></text>
    </g>
  </svg>
  
)
export default Svgyuzbireseksendokuz;

